<form class="example-form" [formGroup]="loginForm">
  <mat-form-field class="w-full">
    <mat-label>Email</mat-label>
    <input
      type="email"
      matInput
      formControlName="emailFormControl"
      [errorStateMatcher]="matcher"
      placeholder="Ex. pat@example.com"
    />
    <mat-hint>Errors appear instantly!</mat-hint>
    @if (
      emailFormControl.hasError('email') &&
      !emailFormControl.hasError('required')
    ) {
      <mat-error> Please enter a valid email address </mat-error>
    }
    @if (emailFormControl.hasError('required')) {
      <mat-error> Email is <strong>required</strong> </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-full">
    <mat-label>Password</mat-label>
    <input
      type="password"
      matInput
      formControlName="passwordFormControl"
      [errorStateMatcher]="matcher"
      placeholder="Ex. pat@example.com"
      autocomplete="on"
    />
    <mat-hint>Errors appear instantly!</mat-hint>
    @if (passwordFormControl.hasError('required')) {
      <mat-error> Password is <strong>required</strong> </mat-error>
    }
  </mat-form-field>
</form>
